<template>
  <div class="btn-group dropup" role="group">
    <button
      :title="meetingPlaceAddress"
      @click.prevent="showMeetingLocation = !showMeetingLocation"
      class="btn btn-primary btn-bar-btn btn-sm apply-plus-btn"
      v-if="task && task.task_type.id === 2 && task.task_location"
    >
      <!--      (!taskInCheckProgress && auth.user.id !== getOriginalCreator())-->
      <i class="fas fa-map-marked-alt"></i>
    </button>

    <button
      title="add new"
      v-if="mode !== 'reply' && mode !== 'reply-email'"
      class="btn btn-primary btn-bar-btn btn-md"
      @click.prevent="addNewTask"
      :class="{ purpleBtn: newTask.taskType.id === 2 }"
      :disabled="
        this.taskTextFromLocalChild.length <= 0 &&
          this.newTaskChild.taskType === null &&
          (this.newTaskChild.taskUser.length <= 0 ||
            this.newTaskChild.taskGroup.length <= 0) &&
          this.newTaskChild.taskDateTime !== null
      "
    >
      <!--      <span v-if="isEmailType">SEND</span><span v-else>{{ newTask.taskType.id === 2 ? "APPLY MEETING" : "APPLY"}}</span>-->
      <span
        >{{ getApplyButtonTitle()
        }}{{ getUserToApplyBtn(newTask.taskUser) }}</span
      >
    </button>
    <button
      type="button"
      class="btn btn-primary dropdown-toggle dropdown-toggle-split repeat-opt-btn"
      :class="{ purpleBtn: newTask.taskType.id === 2 }"
      v-if="
        newTask.taskType.id === 2 && mode !== 'reply' && mode !== 'reply-email'
      "
      @click="showCountryMap = !showCountryMap"
    >
      <i class="fas fa-map-marked-alt"></i>
      <span>
        {{ meetingPlaceAddress }}
      </span>
    </button>
    <button
      type="button"
      class="btn btn-primary dropdown-toggle dropdown-toggle-split repeat-opt-btn"
      data-toggle="dropdown"
      :class="{ purpleBtn: newTask.taskType.id === 2 }"
      v-if="
        newTask.taskType.id === 2 && mode !== 'reply' && mode !== 'reply-email'
      "
      @click="openRepeatedOptions"
    >
      <span class="caret-right"></span>
    </button>
    <div
      class="input-group mb-3 repeat-opt-wrapper"
      v-if="newTask.taskType.id === 2"
    >
      <span v-for="repeat in repeatTypeOptions" v-bind:key="repeat.id">
        <input
          type="radio"
          class="form-check-input repeat-opt-checkbox"
          :id="repeat.title"
          :value="repeat.id"
          v-model="selectedRepOpt"
          name="repeatOptions"
          @click="selectRepeatOption"
        />
        <label class="form-check-label" :for="repeat.title">{{
          repeat.title
        }}</label>
      </span>
      <!--      <div class="item-text" :title="repeat.name" :for="repeat.id">-->
      <!--        {{ " " }}{{ repeat.title }}{{ " " }}-->
      <!--      </div>-->
    </div>
    <button
      title="reply"
      :disabled="!ifReplyToSelected"
      @click.prevent="replyTask"
      class="btn btn-primary btn-bar-btn btn-sm apply-plus-btn"
      v-show="
        checkIfShowReplyBtn() && !ifInSaveDelayCondition
        /* ((mode === 'reply' && selectedTaskTab != 'completed') ||
          (mode === 'reply-email' && task.user_status.status_type.id !== 1)) &&
          showReplyBtn &&
          !optOut &&
          !taskInCheckProgress &&
          taskUserSubStatus != 'Finish it' &&
          !transferUsers[2] &&
          !showUpdateReplyBtn &&
          (auth.user.id !== getOriginalCreator() &&
            taskUserSubStatus != 'For check')*/
      "
    >
      <!--      (!taskInCheckProgress && auth.user.id !== getOriginalCreator())-->
      REPLY
      {{
        task && task.task_type.id != 2 && task
          ? replyUsers[0]
            ? replyUsers[0].full_name
            : ""
          : "ALL"
      }}
    </button>
    <button
      title="update reply"
      :disabled="!ifReplyToSelected || !canTransfer[0]"
      @click.prevent="updateReply"
      class="btn btn-primary btn-bar-btn btn-sm apply-plus-btn"
      v-show="showUpdateReplyBtn"
    >
      <!--      (!taskInCheckProgress && auth.user.id !== getOriginalCreator())-->
      UPDATE REPLY
    </button>
    <button
      title="update reply"
      :disabled="!ifReplyToSelected || !canTransfer[0]"
      @click.prevent="cancelEditReply"
      class="btn btn-primary btn-bar-btn btn-sm apply-plus-btn"
      v-show="showUpdateReplyBtn"
    >
      <!--      (!taskInCheckProgress && auth.user.id !== getOriginalCreator())-->
      CANCEL UPDATE REPLY
    </button>
    <button
      title="transfer"
      @click="checkBeforeTransfer()"
      class="btn btn-primary btn-bar-btn btn-sm"
      v-if="
        ifCreatingTaskOrOnExistingTask() &&
          transferUsers[2] &&
          taskIsNotReadOnly() &&
          this.canTransfer[0]
      "
    >
      TRANSFER to {{ transferUsers[0][0].full_name }}
    </button>
    <button
      type="button"
      class="btn btn-warning btn-bar-btn btn-sm"
      @click="delayTask"
      v-if="
        ifCreatingTaskOrOnExistingTask() &&
          auth.user.id === getOriginalCreator() &&
          ifInSaveDelayCondition
      "
    >
      {{ delayButtonText }}
    </button>
    <button
      type="button"
      class="btn btn-warning btn-bar-btn btn-sm"
      @click="cancelDelayTask"
      v-if="
        ifCreatingTaskOrOnExistingTask() &&
          auth.user.id === getOriginalCreator() &&
          ifInSaveDelayCondition
      "
    >
      CANCEL DELAY
    </button>
    <button
      type="button"
      class="btn btn-warning btn-bar-btn btn-sm"
      @click="clearDelay"
      v-if="
        ifCreatingTaskOrOnExistingTask() &&
          auth.user.id === getOriginalCreator() &&
          taskDelayed
      "
    >
      CLEAR DELAY
    </button>
    <button
      type="button"
      class="btn btn-success btn-bar-btn btn-sm"
      @click="finishQuestion()"
      v-if="ifShowFinishQuestionBtn()"
    >
      FINISH QUESTION
    </button>

    <div class="rating stars-rating" v-if="false">
      <!--      <input name="stars" id="e5" type="radio" /><label for="e5">★</label>-->
      <!--      <input name="stars" id="e5" type="radio" /><label for="e5">☆</label>-->

      <input
        name="selectedProjectCheckStars"
        id="s5"
        type="radio"
        v-model="selectedProjectCheckStars"
        value="s5"
      /><label for="s5">☆</label>
      <input
        name="selectedProjectCheckStars"
        id="s4"
        type="radio"
        v-model="selectedProjectCheckStars"
        value="s4"
      /><label for="s4">☆</label>
      <input
        name="selectedProjectCheckStars"
        id="s3"
        type="radio"
        v-model="selectedProjectCheckStars"
        value="s3"
      /><label for="s3">☆</label>
      <input
        name="selectedProjectCheckStars"
        id="s2"
        type="radio"
        v-model="selectedProjectCheckStars"
        value="s2"
      /><label for="s2">☆</label>
      <input
        name="selectedProjectCheckStars"
        id="s1"
        type="radio"
        v-model="selectedProjectCheckStars"
        value="s1"
      /><label for="s1">☆</label>
    </div>

    <!--    <div class="btns-wrapper">-->
    <button
      class="btn btn-primary btn-bar-btn btn-sm "
      @click="emitCancelCheckMe"
      v-if="
        taskInCheckProgress &&
          taskUserSubStatus != 'Approved' &&
          taskUserSubStatus != 'Finish it' &&
          selectedTaskTab != 'completed' &&
          auth.user.role !== 1 &&
          auth.user.role !== 2 &&
          !ifShowFinishBtn()
      "
    >
      CANCEL CHECK PROJECT
    </button>
    <button
      class="btn btn-primary btn-bar-btn btn-sm"
      @click.prevent="emitRenewTask"
      v-if="
        ifCreatingTaskOrOnExistingTask() &&
          task.user_status.status_id === 1 &&
          auth.user.id === getOriginalCreator()
      "
    >
      RENEW
    </button>
    <button
      class="btn btn-primary btn-bar-btn btn-sm"
      @click="approveIHaveSeenTheAnnouncement()"
      v-if="
        ifCreatingTaskOrOnExistingTask() &&
          (taskIsAnnouncement(task) || taskIsOpenShift(task)) &&
          auth.user.id !== getOriginalCreator()
      "
    >
      I HAVE READ IT
    </button>
    <button
      class="btn btn-primary btn-bar-btn btn-sm check-btn"
      @click.prevent="getWhoIsChecking()"
      v-if="checkIfShowProjectCheckBtn() && !checkIfTaskIsToMySelf()"
    >
      SEND PROJECT CHECK TO {{ getNameWhoIsChecking() }}
    </button>
    <!--    <button-->
    <!--      data-placement="top"-->
    <!--      data-toggle="tooltip"-->
    <!--      :title="getNameWhoIsChecking()"-->
    <!--      class="btn btn-primary btn-bar-btn btn-sm check-btn"-->
    <!--      @click.prevent="getWhoIsChecking()"-->
    <!--      v-if="checkIfShowProjectCheckBtn() && !checkIfTaskIsToMySelf()"-->
    <!--    >-->
    <!--      SEND PROJECT CHECK TO {{ getNameWhoIsChecking() }}-->
    <!--    </button>-->
    <button
      :disabled="
        notApprovedStarsRating === 0 || notApprovedStarsRating === null
      "
      class="btn btn-primary btn-bar-btn btn-sm approved-btn"
      @click="emitApprovedByCreator"
      v-if="
        ifCreatingTaskOrOnExistingTask() &&
          checkIfOriginalCreatorCheckingOrSynthetic() &&
          /*
            auth.user.id === getOriginalCreator() &&
*/
          checkIfThisTaskIsWaitingToBeChecked() &&
          !checkIfThisTaskIsWaitingToBeFinished() &&
          task.user_status.status_id !== 1 &&
          !ifInSaveDelayCondition
      "
    >
      APPROVED
    </button>
    <button
      :disabled="!ifReplyToSelected || !canTransfer[0]"
      class="btn btn-primary btn-bar-btn btn-sm approved-btn"
      @click.prevent="replyTask"
      v-if="
        ifCreatingTaskOrOnExistingTask() &&
          checkIfOriginalCreatorCheckingOrSynthetic() &&
          /* auth.user.id === getOriginalCreator() &&
           */ checkIfThisTaskIsWaitingToBeChecked() &&
          !checkIfThisTaskIsWaitingToBeFinished() &&
          task.user_status.status_id !== 1 &&
          !ifInSaveDelayCondition
      "
    >
      NOT APPROVED
    </button>
    <button
      class="btn btn-primary btn-bar-btn btn-sm finish-btn"
      v-if="ifShowFinishBtn()"
      @click="completeTaskAfterOriginalCreatorChecked()"
    >
      FINISH
    </button>
    <button
      @click="emitIHaveSeenThatTaskIsConfirmed()"
      class="btn btn-primary btn-bar-btn btn-sm"
      v-if="creatorHasConfirmedTheTask && task.user_status.status_id !== 1"
    >
      I have seen that task is confirmed
    </button>
    <button
      @click="emitAddSubTasks"
      class="btn btn-primary btn-bar-btn btn-sm"
      v-if="showSaveSubTasks && mode === 'reply'"
    >
      SAVE SUB TASK(s)
    </button>
    <button
      @click="editTask"
      class="btn btn-primary btn-bar-btn btn-sm edit-btn"
      v-if="
        mode === 'reply' &&
          auth.user.id === getOriginalCreator() &&
          task.task_type.id !== 7 &&
          task.user_status.status_id !== 1 &&
          !taskInCheckProgress &&
          taskUserSubStatus != 'Finish it' &&
          task.task_process_log.length < 2
      "
    >
      {{ editButtonText }}
    </button>
    <button
      @click="addToTask"
      class="btn btn-primary btn-bar-btn btn-sm edit-btn"
      v-if="
        mode === 'reply' &&
          auth.user.id === getOriginalCreator() &&
          task.task_type.id !== 7 &&
          task.user_status.status_id !== 1 &&
          !ifInSaveDelayCondition
      "
    >
      {{ addToTaskButtonText }}
    </button>
    <button
      @click="cancelEditTask"
      class="btn btn-primary btn-bar-btn btn-sm edit-btn"
      v-if="
        mode === 'reply' &&
          auth.user.id === getOriginalCreator() &&
          task.task_type.id !== 7 &&
          task.user_status.status_id !== 1 &&
          editButtonText == 'SAVE TASK'
      "
    >
      CANCEL EDIT TASK
    </button>
    <button
      class="btn btn-warning btn-bar-btn btn-sm"
      v-if="
        mode === 'reply' &&
          task.user_status.status_id !== 1 &&
          task.task_type.id === 7
      "
      @click="emitTaskToJunk"
    >
      To JUNK
    </button>
    <button
      :disabled="syntheticCheckUser.length === 0"
      class="btn btn-success btn-bar-btn btn-sm approved-btn"
      @click="emitSyntheticCheck"
      v-if="ifShowSyntheticCheckBtn()"
    >
      SYNTHETIC PROJECT CHECK
    </button>
    <button
      @click="emitCancelTask"
      class="btn btn-primary btn-bar-btn btn-sm cancel-btn"
      v-if="
        ifCreatingTaskOrOnExistingTask() &&
          auth.user.id === getOriginalCreator() &&
          task.task_type.id !== 7 &&
          task.user_status.status_id !== 1 &&
          taskUserSubStatus != 'Finish it' &&
          !ifInSaveDelayCondition &&
          !ifShowFinishBtn()
      "
    >
      TERMINATE {{ task.task_type.title }}
    </button>
    <button
        @click="calendarTabIsActive()"
        class="btn btn-primary btn-bar-btn btn-sm cancel-btn"
        v-if="
        ifCreatingTaskOrOnExistingTask() &&
          auth.user.id === getOriginalCreator() &&
          task.task_type.id !== 7 &&
          task.user_status.status_id !== 1 &&
          taskUserSubStatus != 'Finish it' &&
          !ifInSaveDelayCondition &&
          !ifShowFinishBtn()
      "
    >
      Reschedule {{ task.task_type.title }}
    </button>
    <div
      class="stars-wrapper"
      v-if="ifShowStarsRating() && !ifInSaveDelayCondition"
      :class="{
        frozen: taskAfterNotApproved
      }"
    >
      <StarRatingComponent
        :grade="notApprovedStarsRating"
        :maxStars="5"
        :hasCounter="false"
        @setRating="setRating"
      />
    </div>
    <div v-if="showCountryMap" class="country-map" v-click-outside="closeMap">
      <!--      <label>-->
      <!--        AutoComplete-->
      <!--        <gmap-autocomplete-->
      <!--          placeholder="This is a placeholder text"-->
      <!--          @place_changed="setPlace"-->
      <!--        >-->
      <!--        </gmap-autocomplete>-->
      <!--&lt;!&ndash;        <GmapAutocomplete></GmapAutocomplete>&ndash;&gt;-->
      <!--&lt;!&ndash;        <button @click="usePlace">Add</button>&ndash;&gt;-->
      <!--      </label>-->
      <GmapMap
        :center="currentLocation"
        :zoom="13"
        map-type-id="terrain"
        style="width: 500px; height: 300px"
        @click="mark"
        :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: true,
          rotateControl: true,
          fullscreenControl: true,
          disableDefaultUi: false
        }"
      >
        <GmapMarker
          :position="currentLocation"
          :clickable="true"
          :draggable="true"
          @dragend="updateCoordinates"
        />
      </GmapMap>
      <!--      <GmapMarker-->
      <!--          :key="index"-->
      <!--          v-for="(m, index) in markers"-->
      <!--          :position="m.position"-->
      <!--          :clickable="true"-->
      <!--          :draggable="true"-->
      <!--        />-->
      <!--      </GmapMap>-->
    </div>
    <div
      v-if="showMeetingLocation"
      class="country-map"
      v-click-outside="closeMap"
    >
      <GmapMap
        :center="currentLocation"
        :zoom="13"
        map-type-id="terrain"
        style="width: 500px; height: 300px"
        :options="{
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: true,
          rotateControl: true,
          fullscreenControl: true,
          disableDefaultUi: false
        }"
      >
        <GmapMarker
          :position="currentLocation"
          :clickable="false"
          :draggable="false"
        />
      </GmapMap>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";

import apiClientCreator from "../../../helpers/api/request";
import StarRatingComponent from "./StarRatingComponent";
import { gmapApi, GmapMarker, GmapAutocomplete } from "vue2-google-maps";

import IPGeolocationAPI from "ip-geolocation-api-javascript-sdk";
import vClickOutside from "v-click-outside";

// import TaskConnectMenu from "./TaskConnectMenu.component";

export default {
  name: "TaskMainWindowButtonsBar",
  computed: {
    google: gmapApi,
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"]),
    ...mapState("tasks", ["taskDictionaries"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"])
  },
  components: {
    StarRatingComponent
    // TaskConnectMenu
  },
  props: {
    replyTaskTextFromLocal: {
      type: String
    },
    taskDelayed: {
      type: Boolean
    },
    ifInSaveDelayCondition: {
      type: Boolean
    },
    syntheticCheckUser: {
      type: Array
    },
    canTransfer: {
      type: Array
    },
    selectedTaskTab: {
      type: String,
      default() {
        return "";
      }
    },
    newTask: {
      type: Object,
      default() {
        return {};
      }
    },
    taskTextFromLocal: {
      type: String,
      default() {
        return "";
      }
    },
    mode: {
      type: String,
      default() {
        return "";
      }
    },
    repeatOptionsObj: {
      type: Object
    },
    repeatTypeOptions: {
      type: Object,
      required: true
    },
    task: {
      type: Object
    },
    taskReplyForCheck: {
      type: Array
    },
    transferUsers: {
      type: Array
    },
    creatorHasConfirmedTheTask: {
      type: Boolean
    },
    taskInCheckProgress: {
      type: Boolean
    },
    taskUserSubStatus: {
      type: String
    },
    replyUsers: {
      type: Array
    },
    showUpdateReplyBtn: {
      type: Boolean
    }
  },
  data() {
    return {
      currentLocation: {
        lat: 40,
        lng: 40
      },
      markerLocation: {
        lat: 40,
        lng: 40
      },
      showMeetingLocation: false,
      meetingPlaceId: null,
      selectedRepOpt: null,
      showCountryMap: false,
      optOut: false,
      newTaskChild: {},
      taskTextFromLocalChild: "",
      transferMode: false,
      notApprovedStarsRating: this.task
        ? this.task.not_approved_rating !== null
          ? this.task.not_approved_rating
          : 0
        : 0,
      // transferToButtonText: "TRANSFER",
      // delayButtonText: "DELAY",
      delayButtonText: "SAVE DELAY",
      editButtonText: "EDIT TASK",
      addToTaskButtonText: "Add to task",
      taskForFuture: false,
      transferAssignment: false,
      showSaveSubTasks: false,
      showReplyBtn: true,
      isEmailType: false,
      transferReplyContent: "",
      taskAfterNotApproved: false,
      // taskAfterNotApproved: this.task.not_approved_rating > 0 ? true : false,
      // taskUserSubStatus: "",
      showCancelCheckBtn: true,
      selectedProjectCheckStars: "s3",
      ifReplyToSelected: true,
      meetingPlaceAddress: ""
      // ifInSaveDelayCondition: false
    };
  },
  currentLocation: null,
  directives: {
    clickOutside: vClickOutside.directive
  },
  watch: {
    // canTransfer(){
    // },
    selectedRepOpt() {
      this.$emit("setRepOpt", this.selectedRepOpt);
    },
    taskForFuture() {
      this.thisTaskIsForTheFuture();
    },
    replyUsers() {
      if (this.replyUsers.length === 0) {
        this.ifReplyToSelected = false;
      } else {
        this.ifReplyToSelected = true;
      }
    }
  },
  methods: {
    calendarTabIsActive(){
      this.$emit("changeActiveTaskTab", { tab: "CAL", estTime: '3 hours'})
    },
    getLocationFromJson(location) {
      let coordinatesObj = JSON.parse(location);
      this.currentLocation.lat = coordinatesObj.lat;
      this.currentLocation.lng = coordinatesObj.lng;
    },
    setDescription(description) {
      this.description = description;
    },
    setPlace(place) {
      this.place = place;
    },
    usePlace(place) {
      if (this.place) {
        this.markers.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          }
        });
        this.place = null;
      }
    },

    getPlaceId(location) {
      const geocoder = new google.maps.Geocoder();
      let latitude = location.lat;
      let longitude = location.lng;
      let latlng = { lat: parseFloat(latitude), lng: parseFloat(longitude) };

      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[1]) {
            this.meetingPlaceId = results[1].place_id;
            this.getPlaceByPlaceId(this.meetingPlaceId, geocoder);
            // this.meetingPlaceId = results[1].place_id
          } else {
            this.meetingPlaceAddress = "";
            // window.alert('No results found');
          }
        } else {
          this.meetingPlaceAddress = "";

          // window.alert('Geocoder failed due to: ' + status);
        }
      });
    },
    getPlaceByPlaceId(placeId) {
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ placeId: placeId }, (results, status) => {
        this.meetingPlaceAddress = results[0].formatted_address;
      });
    },
    async updateCoordinates(location) {
      this.currentLocation = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
      await this.getPlaceId(this.currentLocation);
      setTimeout(() => {
        this.$emit("setMeetingLocation", {
          coordinates: JSON.stringify(this.currentLocation),
          placeId: this.meetingPlaceId
        });
      }, 1000);
      // this.$emit("setMeetingLocation", {coordinates: JSON.stringify(this.currentLocation), placeId: this.meetingPlaceId})
    },
    async mark(event) {
      this.currentLocation = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      };
      await this.getPlaceId(this.currentLocation);

      this.showCountryMap = false;

      this.$emit("setMeetingLocation", {
        coordinates: JSON.stringify(this.currentLocation),
        placeId: this.meetingPlaceId
      });
    },
    ifShowStarsRating() {
      if (this.task) {
        if (this.task.task_check.length > 0) {
          if (this.checkIfThisTaskIsWaitingToBeChecked()) {
            return true;
          } else {
            return true;
          }
        } else {
          if (this.task.not_approved_rating !== null) {
            this.taskAfterNotApproved = true;
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    closeMap() {
      this.showCountryMap = false;
      this.showMeetingLocation = false;
    },
    setRating(rating) {
      this.notApprovedStarsRating = rating;
      this.$emit("star-rating", rating);
    },
    openRepeatedOptions() {
      $(".repeat-opt-wrapper").toggle("slow");
    },
    selectRepeatOption() {
      $(".repeat-opt-wrapper").toggle("slow");
      this.$emit("setRepOpt", this.selectedRepOpt);
    },
    getUserToApplyBtn(taskUser) {
      if (taskUser.length === 0) {
        return " ";
      } else if (taskUser.length === 1) {
        return ` to ${taskUser[0].full_name}`;
      } else {
        return ` to ${taskUser.length} person`;
      }
    },
    getApplyButtonTitle() {
      if (this.isEmailType) {
        return "SEND EMAIL";
      }
      if (this.newTask.taskType.id === 1) {
        switch (this.repeatOptionsObj.option) {
          case null:
            return "APPLY TASK";
          case 8:
            return "APPLY ANNOUNCEMENT";
          case 9:
            return "APPLY OPEN SHIFT";
          case 10:
            return "APPLY QUESTION";
          case 11:
            return "APPLY COMP. EVENT";
          default:
            return "APPLY TASK";
        }
        // if(this.repeatOptionsObj.option === null ){
        // }
      } else if (this.newTask.taskType.id === 2) {
        return "APPLY MEETING";
      } else if (this.newTask.taskType.id === 10) {
        return "APPLY OUTLINE";
      }
      else if (this.newTask.taskType.id === 11) {
          return "APPLY COMP. EVENT";
      }
    },

    checkIfShowReplyBtn() {
      if (this.checkIfThisSyntheticCheck()) {
        return false;
      }
      if (
        (this.mode === "reply" && this.selectedTaskTab != "completed") ||
        (this.mode === "reply-email" &&
          this.task.user_status.status_type.id !== 1)
      ) {
        if (
          this.showReplyBtn &&
          !this.optOut &&
          !this.taskInCheckProgress &&
          this.taskUserSubStatus != "Finish it" &&
          !this.transferUsers[2] &&
          !this.showUpdateReplyBtn
        ) {
          if (this.auth.user.id !== this.getOriginalCreator()) {
            return true;
          } else {
            if (this.taskUserSubStatus == "For check") {
              return false;
            } else {
              return true;
            }
          }
        }
      }
    },
    checkIfShowProjectCheckBtn() {
      if (
        this.checkIfThisTaskIsTransferredToMe() &&
        !this.originalCreatorHasCheckedTheTask() &&
        this.task.user_status.status_id !== 1 &&
        // this.task.task_type.type != "MEETING" &&
        !this.oneToOneCreatorApproved() &&
        !this.taskInCheckProgress
      ) {
        return true;
      }
    },
    ifShowFinishBtn() {
      if (this.task) {
        if (
          this.selectedTaskTab == "active" ||
          this.selectedTaskTab == "outline"
        ) {
          if (
            (this.ifCreatingTaskOrOnExistingTask() &&
              this.oneToOneCreatorApproved()) ||
            (this.checkIfTaskIsToMySelf() && !this.checkIfThisSyntheticCheck())
          ) {
            return true;
          } else {
            if (
              this.task.task_type.id === 2 &&
              moment(this.task.end_time).format() < moment().format() &&
              this.auth.user.id === this.getOriginalCreator()
            ) {
              return true;
            }
          }
        } else {
          return false;
        }
      }
    },
    ifShowFinishQuestionBtn() {
      if (this.task) {
        if (
          this.getOriginalCreator() === this.auth.user.id &&
          this.task.task_sub_type.id === 6
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    ifShowSyntheticCheckBtn() {
      if (
        this.ifCreatingTaskOrOnExistingTask() &&
        this.auth.user.id === this.getOriginalCreator() &&
        this.checkIfThisTaskIsWaitingToBeChecked() &&
        !this.checkIfThisTaskIsWaitingToBeFinished() &&
        this.task.user_status.status_id !== 1 &&
        !this.ifInSaveDelayCondition &&
        this.selectedTaskTab == "active"
      ) {
        return true;
      } else if (
        this.checkIfTaskIsToMySelf() &&
        this.selectedTaskTab == "active"
      ) {
        return true;
      } else {
        return false;
      }
    },
    checkIfTaskIsToMySelf() {
      if (this.task) {
        if (this.task.transfer.length > 0) {
          if (
            this.task.transfer[0].transfer_to.id ===
            this.task.transfer[0].transfer_by.id
          ) {
            return true;
          }
        }
      }
    },
    // getUserTaskSubStatus() {
    //   if (this.task.taskSubStatus.length) {
    //     const subStat = this.task.taskSubStatus.find(
    //       user => user.user_id === this.auth.user.id
    //     );
    //     this.taskUserSubStatus = subStat.task_sub_status_type.title;
    //   }
    // },
    cancelEditTask() {
      this.editButtonText = "EDIT TASK";
      this.$emit("cancelEditTask");
    },
    taskIsAnnouncement(task) {
      if (task.task_sub_type) {
        if (task.task_sub_type.id === 4) {
          return true;
        }
      } else {
        return this.task.taskSubStatus.some(
          sub => sub.sub_status_id === 31 && sub.user_id === this.auth.user.id
        );
      }
    },
    taskIsOpenShift(task) {
      if (task.task_sub_type) {
        if (task.task_sub_type.id === 5) {
          return true;
        }
      } else {
        return this.task.taskSubStatus.some(
          sub => sub.sub_status_id === 46 && sub.user_id === this.auth.user.id
        );
      }
    },
    approveIHaveSeenTheAnnouncement() {
      this.$store.commit("clients/setLoading", true);

      const userApproveAnnouncement = apiClientCreator(
        `tasks/user_approve_announcement/${this.task.id}`
      );
      userApproveAnnouncement.post("").then(res => {
        this.$emit("closeMainTaskWindow");
        this.$emit("clear_sets");
        this.$store.commit("tasks/setFetchTasks", { flag: true });
        // this.$root.$emit("change_tab_to_waiting");
      });

      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "You Approved The Announcement successfully",
        type: "DONE",
        op: { type: "SYSTEM" }
      });
      this.$store.commit("clients/setLoading", false);
    },
    oneToOneCreatorApproved() {
      if (this.ifCreatingTaskOrOnExistingTask()) {
        return this.task.taskSubStatus.some(
          subStatus =>
            (subStatus.user_id === this.auth.user.id &&
              subStatus.sub_status_id === 41) ||
            subStatus.sub_status_id === 45
        );
      }
    },
    emitApprovedByCreator() {
      this.$emit("approvedByCreator");
    },

    // approvedByCreator() {
    //   this.$store.commit("clients/setLoading", true);
    //
    //   const creatorApprove = apiClientCreator(
    //     `tasks/approved_by_creator/${this.task.id}`
    //   );
    //   creatorApprove.post("").then(res => {
    //     this.$emit("clear_sets");
    //     this.$store.commit("tasks/setFetchTasks", { flag: true });
    //     this.$root.$emit("change_tab_to_waiting");
    //   });
    //   this.$store.commit("main/setShowVikiMsg", {
    //     show: true,
    //     msg: "Creator Approved",
    //     type: "DONE",
    //     op: { type: "SYSTEM" }
    //   });
    //   this.$store.commit("clients/setLoading", false);
    // },
    taskIsNotReadOnly() {
      return !this.task.task_read_only.some(
        user => user.user_id === this.auth.user.id
      );
    },
    async checkBeforeTransfer() {
      let far = document.querySelectorAll(".far");

      let ids = [];
      far.forEach(el => ids.push(parseInt(el.dataset.star)));

      if (this.transferUsers.length > 0) {
        let apiClient = apiClientCreator(
          `tasks/transfer_task/${this.transferUsers[1]}`
        );
        let transferToIds = [];
        this.transferUsers[0].forEach(user => {
          transferToIds.push(user.id);
        });
        let reply = this.canTransfer[1];
        this.$root.$emit("task_transfer", this.task.id);

        await apiClient
          .post("", {
            transfer_to: transferToIds,
            task_read_only: ids,
            reply_content: reply
          })
          .then(res => {
            // this.showReplyTaskText = false;
            this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg: "Task regular transferred successfully",
              type: "DONE",
              op: { type: "SYSTEM" }
            });
            this.$store.commit("tasks/setFetchTasks", { flag: true });
            this.$emit("closeMainTaskWindow");
          })
          .catch(e => {
            this.$store.commit("main/setShowVikiMsg", {
              show: true,
              msg:
                "Connection Error!" +
                " " +
                " Error Status: " +
                e.response.status,
              type: "ERROR",
              op: { type: "SYSTEM" }
            });

            this.$store.commit("clients/setLoading", false);
          });
      }
    },

    emitCancelTask() {
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Are you sure?",
        type: "WARNING",
        op: { type: "CANCEL TASK", taskId: this.task.id }
      });
      // this.$emit("cancelTask");
    },
    thisTaskIsForTheFuture() {
      if (this.taskForFuture) {
        this.$emit("taskForFuture", 10);
        //this.newTask.taskType.id = 10;
      } else {
        this.$emit("taskForFuture", 1);
        //this.newTask.taskType.id = 1;
      }
    },
    emitIHaveSeenThatTaskIsConfirmed() {
      this.$emit("IHaveSeenThatTaskIsConfirmed");
    },
    emitReplyEndTask() {
      this.$emit("replyEndTask");
    },
    emitRenewTask() {
      this.$emit("renewTask");
    },
    // sendConnectedTask(id) {
    //   this.$emit("setConnectedTask", id);
    // },
    emitTaskToJunk() {
      this.$emit("taskToJunk", { status_id: 1, sub_status_id: 12 });

      // this.$emit('setConnectedTask', id)
    },

    ifCreatingTaskOrOnExistingTask() {
      return typeof this.task !== "undefined";
    },
    creatorConfirm() {
      this.$store.commit("clients/setLoading", true);

      const addNewClientRequest = apiClientCreator(
        `tasks/confirmTaskCompleted/${this.task.id}`
      );
      addNewClientRequest.post("").then(res => {});
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Status changed to completed for you",
        type: "DONE",
        op: { type: "SYSTEM" }
      });
      this.$store.commit("clients/setLoading", false);
      // this.showReplyTaskText = false;
      // this.$emit("updated");
      this.$store.commit("tasks/setFetchTasks", { flag: true });
      this.$emit("clear_sets");
    },
    ConfirmAfterAllReplied() {
      let creator = this.getOriginalCreator();
      let exceptOriginal = this.filterOriginalCreator();
      let whoRepliedWithoutCreator = this.getIdsOfWhoRepliedExceptCreator(
        creator
      );
      exceptOriginal = [...new Set(exceptOriginal)];
      whoRepliedWithoutCreator = [...new Set(whoRepliedWithoutCreator)];
      exceptOriginal.sort((a, b) => a - b);
      whoRepliedWithoutCreator.sort((a, b) => a - b);

      // Check if the arrays are the same length
      if (exceptOriginal.length !== whoRepliedWithoutCreator.length) {
        return false;
      }

      for (let i = 0; i < exceptOriginal.length; i++) {
        if (exceptOriginal[i] !== whoRepliedWithoutCreator[i]) return false;
      }
      if (this.auth.user.id !== creator) {
        return false;
      }
      if (this.auth.user.id === creator) {
        return true;
      }
    },
    getIdsOfWhoRepliedExceptCreator(originalCreator) {
      let WhoRepliedExceptCreator = [];
      this.task.reply.forEach(reply => {
        WhoRepliedExceptCreator.push(reply.user.id);
      });
      let repliesExceptOriginal = WhoRepliedExceptCreator.filter(
        item => item !== originalCreator
      );
      return repliesExceptOriginal;
    },
    getAllUsersExceptOriginal(originalCreator) {
      let assigned_to = [];
      this.task.task_assignment.forEach(assign => {
        assigned_to.push(assign.assigned_to.id);
      });

      let exceptOriginal = assigned_to.filter(item => item !== originalCreator);

      return exceptOriginal;
    },
    filterOriginalCreator() {
      let exceptOriginal = this.getAllUsersExceptOriginal(
        this.getOriginalCreator()
      );
      return exceptOriginal;
    },
    originalCreatorHasCheckedTheTask() {
      if (this.ifCreatingTaskOrOnExistingTask()) {
        return (
          this.task.task_check.some(t => t.is_creator === 1) &&
          this.checkIfThisTaskIsTransferredToMe() &&
          this.task.user_status.status_type.id !== 1 &&
          this.task.user_status.status_type.id !== 6
        );
      }
    },
    async completeTaskAfterOriginalCreatorChecked() {
      const data = {};
      if (this.replyTaskTextFromLocal) {
        Object.assign(data, {
          reply_content: this.replyTaskTextFromLocal + ", task finished"
        });
      }
      this.$store.commit("clients/setLoading", true);

      const addNewClientRequest = apiClientCreator(
        `tasks/complete_task_after_original_creator_checked/${this.task.id}`
      );

      await addNewClientRequest.post("", data).then(res => {
        this.$emit("closeMainTaskWindow");

        // this.$root.$emit("task_transfer", this.task.id); //TODO: ADDED to stop clock
      });
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Task finished",
        type: "DONE",
        op: { type: "SYSTEM" }
      });

      this.$store.commit("clients/setLoading", false);
      // this.showReplyTaskText = false;

      // this.$root.$emit("task_competed", this.task.id);
      this.$store.commit("tasks/setFetchTasks", { flag: true });
    },
    async finishQuestion() {
      const data = {};
      if (this.replyTaskTextFromLocal) {
        Object.assign(data, {
          reply_content: this.replyTaskTextFromLocal + ", question closed"
        });
      }
      this.$store.commit("clients/setLoading", true);

      const addNewClientRequest = apiClientCreator(
        `tasks/complete_question/${this.task.id}`
      );

      await addNewClientRequest.post("", data).then(res => {
        this.$emit("closeMainTaskWindow");

        // this.$root.$emit("task_transfer", this.task.id); //TODO: ADDED to stop clock
      });
      this.$store.commit("main/setShowVikiMsg", {
        show: true,
        msg: "Task finished",
        type: "DONE",
        op: { type: "SYSTEM" }
      });

      this.$store.commit("clients/setLoading", false);
      // this.showReplyTaskText = false;

      // this.$root.$emit("task_competed", this.task.id);
      this.$store.commit("tasks/setFetchTasks", { flag: true });
    },
    getOriginalCreator() {
      let originalCreator = null;
      if (this.task) {
        this.task.task_assignment.forEach(assign => {
          if (assign.assigned_to.id === assign.assigned_by.id) {
            originalCreator = assign.assigned_by.id;
          }
        });
      }

      return originalCreator;
    },
    checkAfterApprove() {
      let transferredToMe = this.checkIfThisTaskIsTransferredToMe();
      if (!transferredToMe) {
        let creator = this.getOriginalCreator();
        this.emitCheckMe(creator);
      }
    },
    checkIfThisTaskIsWaitingToBeFinished() {
      if (this.ifCreatingTaskOrOnExistingTask()) {
        return this.task.taskSubStatus.some(
          subStatus =>
            subStatus.user_id === this.auth.user.id &&
            subStatus.sub_status_id === 45
        );
      }
    },
    checkIfThisTaskIsWaitingToBeChecked() {
      if (this.ifCreatingTaskOrOnExistingTask()) {
        return this.task.task_check.some(
          t => t.is_checking === this.auth.user.id
        );
      }
    },
    checkIfThisSyntheticCheck() {
      if (this.ifCreatingTaskOrOnExistingTask()) {
        return this.task.task_check.some(
          t =>
            t.is_checking === this.auth.user.id &&
            t.requested_check === this.getOriginalCreator()
        );
      }
    },
    checkIfOriginalCreatorCheckingOrSynthetic() {
      if (this.auth.user.id === this.getOriginalCreator()) {
        return true;
      } else {
        // if (this.checkIfThisSyntheticCheck() && this.auth.user.id === 22) {
        if (this.checkIfThisSyntheticCheck()) {
          return true;
        } else {
          return false;
        }
      }
    },
    checkIfThisTaskIsTransferredToMe() {
      if (this.ifCreatingTaskOrOnExistingTask()) {
        return this.task.transfer.some(
          t => t.transfer_to.id === this.auth.user.id
        );
      }
    },
    emitCheckMe(id) {
      this.$emit("checkMe", id);
    },
    emitSyntheticCheck() {
      this.$emit("syntheticCheck", 56); // TODO only need to change id to 56
    },
    emitCancelCheckMe() {
      this.task.transfer.forEach(t => {
        if (t.transfer_to.id === this.auth.user.id) {
          this.$emit("cancelCheck", t.transfer_by.id);
        }
      });
    },
    getNameWhoIsChecking() {
      let nameWhoIsChecking = "";
      this.task.transfer.forEach(t => {
        if (t.transfer_to.id === this.auth.user.id) {
          nameWhoIsChecking = t.transfer_by.full_name;
        }
      });
      return nameWhoIsChecking;
    },
    getWhoIsChecking() {
      this.task.transfer.forEach(t => {
        if (t.transfer_to.id === this.auth.user.id) {
          this.emitCheckMe(t.transfer_by.id);
        }
      });
    },

    addNewTask() {
      this.$emit("addNewTask");
    },
    getMyTasks() {
      this.$emit("getMyTasks");
    },
    //  transferTo() {
    //   this.checkBeforeTransfer()
    // },
    checkOwnership() {
      let arr = [];
      for (let i = 0; i < this.task.task_assignment.length; i++) {
        arr.push(this.task.task_assignment[i].assigned_by.id);
      }
      let creators = [...new Set(arr)];

      return creators.includes(this.auth.user.id);
    },
    editTask() {
      if (this.editButtonText == "EDIT TASK") {
        this.editButtonText = "SAVE TASK";
        this.$emit("editTask");
      } else if (this.editButtonText == "SAVE TASK") {
        this.editButtonText = "EDIT TASK";
        this.$emit("saveEditedTask");
      }
    },
    cancelDelayTask() {
      this.$emit("cancelDelayTask");
    },
    clearDelay() {
      this.$emit("clearDelay");
    },
    delayTask() {
      if (this.delayButtonText == "DELAY") {
        this.delayButtonText = "SAVE DELAY";
        // this.ifInSaveDelayCondition = true;
        this.$emit("delayTask");
      } else if (this.delayButtonText == "SAVE DELAY") {
        this.delayButtonText = "DELAY";
        // this.ifInSaveDelayCondition = false;
        this.$emit("saveDelay");
      }
    },
    addToTask() {
      if (this.addToTaskButtonText == "Add to task") {
        this.addToTaskButtonText = "Save addons";
        this.$emit("addToTask");
      } else if (this.addToTaskButtonText == "Save addons") {
        this.addToTaskButtonText = "Add to task";
        this.$emit("saveAddons");
      }
    },
    replyTask() {
      this.$emit("replyTask");
    },
    currentGeoLocation() {
      navigator.geolocation.getCurrentPosition(position => {
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      });
    },
    // getIpToLocation() {
    //     const ipgeolocationApi = new IPGeolocationAPI(
    //             "18a036382714417c83ad3b90936787b7",
    //             false
    //     );
    //     const GeolocationParams = require("ip-geolocation-api-javascript-sdk/GeolocationParams.js");
    //     const geolocationParams = new GeolocationParams();
    //     geolocationParams.getCurrentPosition(
    //             function success(position) {
    //               // for when getting location is a success
    //                       'longitude', position.coords.longitude);
    //             },
    // );
    //     geolocationParams.setIPAddress(this.client.last_ip);
    //     geolocationParams.setFields("geo,time_zone,currency");
    //
    //     ipgeolocationApi.getGeolocation(this.handleResponse, geolocationParams);
    //
    // },
    updateReply() {
      this.showUpdateReplyBtn = false;
      this.$emit("updateReply");
    },
    cancelEditReply() {
      this.showUpdateReplyBtn = false;
      this.$emit("cancelEditReply");
    },
    replyEndTask() {
      this.$emit("replyEndTask");
    },
    changeNewTaskPriority: function(e) {
      let taskPriority = {
        id: e.target.checked ? 1 : 2,
        type: e.target.checked ? "HIGH" : "LOW",
        title: e.target.checked ? "High Priority" : "Low Priority"
      };
      this.$emit("changeNewTaskPriority", taskPriority);

      // this.newTask.taskPriority = taskPriority;
    },
    emitTransferAss() {
      this.$root.$emit("emitTransferAss");
    },
    emitAddSubTasks() {
      this.$emit("emitAddNewSubTasks");
    }
  },
  beforeMount() {
    this.newTaskChild = this.newTask; // save props data to itself's data and deal with it
    this.taskTextFromLocalChild = this.taskTextFromLocal;
  },
  mounted() {
    $(document).ready(function() {
      // $(".repeat-opt-wrapper").hide();
      $(".repeat-opt-btn").click(function() {
        // $(".repeat-opt-wrapper").toggle("slow");
      });
      $(".repeat-opt-checkbox").click(function() {});

      // $("#close-alert-box-news").click(function() {
      //   $("#alert-box-news").hide("slide", {direction: "right"}, "fast");
      // });
    });
    this.currentGeoLocation();
    if (this.task) {
      if (this.task.task_location) {
        this.getLocationFromJson(this.task.task_location.coordinates);
        this.getPlaceByPlaceId(this.task.task_location.place_id);
      }
      if (this.task.optout.length > 0) {
        let email = this.task.optout[0]["email_from"];

        apiClientCreator(`tasks/checkIfOptOut/${email}`)
          .post("", {})
          .then(result => {
            if (result.data === 1) {
              this.optOut = true;
            }
            if (result.data === 0) {
              this.optOut = false;
            }
          })
          .catch(err => {});
      }
      if (this.task.not_approved_rating > 0) {
        this.taskAfterNotApproved = true;
      }
      $(document).ready(function() {
        $('[data-toggle="tooltip"]').tooltip();
        $("#s2").focus();
      });
    }
    this.$root.$on("user_to_reply_is_selected", data => {
      this.ifReplyToSelected = true;
    });
    this.$root.$on("give_me_the_button", data => {
      this.transferAssignment = !this.transferAssignment;
    });
    this.$root.$on("show_save_add_sub_tasks", data => {
      this.showSaveSubTasks = data;
      this.showReplyBtn = !data;
    });
    this.$root.$on("show_reply_button", data => {
      this.showReplyBtn = data;
    });

    this.$root.$on("revertTaskTypeFromEmailToTask", () => {
      this.isEmailType = false;
    });

    this.$root.$on("changeTaskTypeToEmail", () => {
      this.isEmailType = true;
    });
  },

  beforeDestroy() {
    this.$root.$off("user_to_reply_is_selected");
  }
};
</script>

<style scoped>
.buttons-container {
  width: 100%;
}
.btn {
  margin-right: 10px;
}
.checkbox-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 12px;
  margin-left: 5px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: 100;
}

/* Hide the browser's default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  /*height: 37px;*/
  /*width: 37px;*/
  height: 25px;
  width: 25px;
  background-color: #eee;
  border: 1px solid gray;
}

/* On mouse-over, add a grey background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: #ccc;
}
.transfer-to-users-box {
  position: absolute;
  right: -32px;
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}

.stay-open-transfer {
  display: block !important;
  max-height: 525px;
  top: -13px;
  position: absolute;
  left: -32px;
  width: 200px;
  box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
}
/* When the checkbox is checked, add a blue background */
.checkbox-container input:checked ~ .checkmark {
  /*background-color: #44a2d2;*/
  background-color: #ff0000;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  /*left: 17px;*/
  /*top: 7px;*/
  /*width: 5px;*/
  /*height: 21px;*/
  left: 6px;
  top: 0px;
  width: 12px;
  height: 19px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.btn-bar-btn {
  /*height: 10px!important;*/
  margin-bottom: 7px;
  margin-right: 0px;
}
.btn-group-sm > .btn,
.btn-sm {
  font-size: 10px;
}
/*.cancel-btn {*/
/*  left: 111px !important;*/
/*  z-index: 3;*/

/*}*/
/*.approved-btn{*/
/*  position: absolute;*/
/*  left: 1119px !important;*/
/*  z-index: 3;*/
/*  top: 7px;*/
/*  border-radius: 0px;*/
/*}*/
/*.finish-btn{*/
/*  position: absolute;*/
/*  left: 1019px !important;*/
/*  z-index: 3;*/
/*  top: 7px;*/
/*  border-radius: 0px;*/
/*}*/
/*.cancel-check-btn{*/
/*  !*left: 111px !important;*!*/
/*  !*.edit-btn{*!*/
/*  top: -12px;*/
/*  position: absolute;*/
/*}*/
/*.edit-btn{*/
/*  position: absolute;*/
/*  left: 808px !important;*/
/*  z-index: 3;*/
/*  top: 7px;*/
/*  border-radius: 0px;*/
/*}*/
/*.apply-plus-btn{*/
/*  margin-top: -12px;*/
/*  padding: 17px!important;*/
/*  font-weight: 700;*/
/*  font-size: 15px;*/
/*  letter-spacing: 1px;*/
/*}*/
.btns-wrapper {
  /*left: 807px;*/
  left: 1349px;
  z-index: 2;
  top: 131px;
  /*top: 181px;*/
  position: absolute;
  display: flex;
}

.btns-wrapper button {
  border-radius: 0px;
}
.purpleBtn {
  background-color: #7b1fa2;
  border-color: #7b1fa2;
}

em {
  display: block;
  margin: 0.5em auto 2em;
  color: #bbb;
}

/*
 * Rating styles
 */
/*.rating {*/
/*  width: 226px;*/
/*  margin: 0 auto 1em;*/
/*  font-size: 45px;*/
/*  overflow: hidden;*/
/*}*/
/*.stars-rating {*/
/*  width: 226px;*/
/*  margin: 0 auto 1em;*/
/*  font-size: 36px;*/
/*  overflow: hidden;*/
/*  position: absolute;*/
/*  top: -13px;*/
/*  left: 10px;*/
/*}*/

/*.rating input {*/
/*  float: right;*/
/*  opacity: 0;*/
/*  position: absolute;*/
/*}*/
/*.rating a,*/
/*.rating label {*/
/*  float: right;*/
/*  color: #aaa;*/
/*  text-decoration: none;*/
/*  -webkit-transition: color 0.4s;*/
/*  -moz-transition: color 0.4s;*/
/*  -o-transition: color 0.4s;*/
/*  transition: color 0.4s;*/
/*}*/
/*.rating label:hover ~ label,*/
/*.rating input:focus ~ label,*/
/*.rating label:hover,*/
/*.rating a:hover,*/
/*.rating a:hover ~ a,*/
/*.rating a:focus,*/
/*.rating a:focus ~ a {*/
/*  color: orange;*/
/*  cursor: pointer;*/
/*}*/
/*.rating2 {*/
/*  direction: rtl;*/
/*}*/
/*.rating2 a {*/
/*  float: none;*/
/*}*/
.stars-wrapper {
  font-family: "Spartan", sans-serif;
  display: inherit;
  /*display: flex;*/
  align-items: center;
  justify-content: center;
  z-index: 2;
  /*height: 100vh;*/
}
.frozen {
  opacity: 0.5;
  pointer-events: none;
}
.caret-right {
  border-bottom: 6px solid transparent;
  border-top: 6px solid transparent;
  border-left: 6px solid;
  display: inline-block;
  height: 0;
  opacity: 1;
  vertical-align: middle;
  width: 0;
}
.repeat-opt-wrapper {
  background-color: #7b1fa2;
  padding: 5px;
  vertical-align: middle;
  padding-bottom: 2px;
  border-radius: 0px 5px 5px 0px;
  color: white;
  float: left;
  display: none;
}
.repeat-opt-btn {
  background-color: #7b1fa2;
  margin-right: -2px;
}
.btn-primary:active,
.btn-primary.active,
.open > .dropdown-toggle.btn-primary {
  color: #fff;
  background-color: #7b1fa2;
  border-color: #7b1fa2;
}
.repeat-opt-checkbox {
  margin-left: 5px;
  margin-right: 5px;
}
.form-check-label,
.repeat-opt-checkbox {
  cursor: pointer;
}
.country-map {
  position: absolute;
  padding: 8px;
  bottom: 39px;
  /*right: -340px;*/
  z-index: 10001;
  border: solid 1px #90a4ae;
  width: max-content;
  height: max-content;
  /*  border-radius: 5px;*/
  background-color: #fff;
  /*  -webkit-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
    -moz-box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);
    box-shadow: 4px 4px 11px -4px rgba(0, 0, 0, 0.75);*/
}
</style>
